<template>
  <b-form-group
    label="Katalog Durumu"
    label-for="id_catalog_statuses"
  >
    <validation-provider
      #default="{ errors }"
      name="Katalog Durumu"
      rules="required"
    >
      <v-select
        id="id_catalog_statuses"
        v-model="dataItem.id_catalog_statuses"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
        :disabled="isNew"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'CatalogStatus',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['catalogs/dataItem']
    },
    dataList() {
      return this.$store.getters['catalogStatuses/dataList']
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  mounted() {
    this.setDefaultStatus()
  },
  methods: {
    setDefaultStatus() {
      if (this.isNew) {
        this.dataItem.id_catalog_statuses = '1'
      }
    },
    getData() {
      this.$store.dispatch('catalogStatuses/getDataList', {
        select: [
          'catalog_statuses.id AS id',
          'catalog_statuses.title AS title',
        ],
      })
    },
  },
}
</script>
